<!--
招标流程弹框
-->
<template>
  <el-dialog
    style="height:100%"
    :width="windowW"
    :fullscreen="true"
    :show-close="false"
    v-bind="this.$attrs"
    :before-close="handleCloseWindow"
  >
    <iframe
      :width="windowW"
      height="100%"
      :src="flowSrc"
      class="el-frame-iframe"
    >
    </iframe>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // surcingData: {
    //   type: Object,
    //   default() {
    //     return {};
    //   }
    // }
  },
  data() {
    return {
      title: "采购寻源流程",
      ready: false,
      flowSrc:
        `/${
          JSON.parse(sessionStorage.getItem("expertSourceData") || "{}")
            .supplierFlag === 1
            ? "subSourcingFlow" // 分包商电子评标
            : "sourcingFlow"
        }?a=` +
        this.$router.history.current.query.a +
        "&&menuKey=" +
        this.$router.history.current.query.menuKey
    };
  },
  watch: {},
  mounted() {
    let _this = this;
    window.addEventListener("message", function(e) {
      if (e.data == false) {
        _this.handleCloseWindow();
        let el = document;
        let cfs =
          el.cancelFullScreen ||
          el.webkitCancelFullScreen ||
          el.mozCancelFullScreen ||
          el.msCancelFullscreen;
        if (document.fullscreenElement !== null) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        } else if (typeof window.ActiveXObject !== "undefined") {
          // eslint-disable-next-line no-undef
          let wscript = new ActiveXObject("WScript.Shell");
          if (wscript != null) {
            wscript.SendKeys("{F11}");
          }
        }
      }
    });
  },
  computed: {
    windowW() {
      return `${document.body.clientWidth - 20}px`;
    }
  },
  methods: {
    handleCloseWindow() {
      this.visible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-frame-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
/deep/ .el-dialog {
  border-radius: 0 !important;
  .el-dialog__header {
    padding: 0 !important;
    border-bottom: 0;
    position: absolute;
    right: 100px;
    top: 20px;
    color: #ffffff;
  }
  .el-dialog--customize__body {
    padding: 0 !important;
    max-height: 100vh !important;
    overflow: hidden !important;
    //height: calc(100% - 366px);
    //height: calc(100% - 20px);
    height: 100%;
    & > div {
      height: 100%;
    }
  }
}
</style>
